<template>
  <div>
    <v-container v-html="$t('landing.disclaimer')"></v-container>
    <v-container>
      <v-divider class="mb-4"></v-divider>
      <h2>User Guide</h2>
      <v-row>
        <v-col style="flex: 0 0 350px"
          >1) For Contract Management & Dimbook</v-col
        >
        <v-col style="flex: 1 1 0">
          <a
            href="User_Guide_for_Contract_Mgt_Dimbook_v1_1.pdf"
            target="_blank"
            style="color: var(--v-primary-base)"
            >Click here</a
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col style="flex: 0 0 350px">2) For SoR Generation</v-col>
        <v-col style="flex: 1 1 0">
          <a
            href="User_Guide_for_SoR_Generation_v1_3.pdf"
            target="_blank"
            style="color: var(--v-primary-base)"
            >Click here</a
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col style="flex: 0 0 350px">3) For RBU</v-col>
        <v-col style="flex: 1 1 0">
          <a
            href="e-RBU_User_Manual.pdf"
            target="_blank"
            style="color: var(--v-primary-base)"
            >Click here</a
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col style="flex: 0 0 350px">4) Training video for adjustment</v-col>
        <v-col style="flex: 1 1 0">
          <a
            href="adjustment_training.mov"
            target="_blank"
            style="color: var(--v-primary-base)"
            >Click here</a
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col style="flex: 0 0 350px">5) Training video for estimation</v-col>
        <v-col style="flex: 1 1 0">
          <a
            href="estimation_training.mov"
            target="_blank"
            style="color: var(--v-primary-base)"
            >Click here</a
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Landing",

  mounted() {
    // this.$router.replace({name: 'equipment-list'})
  },
};
</script>
